import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CategoryQuery } from '@core/types';
import { ApiResponse } from '@core/types/api-response.model';

import { ApiService } from '../api.service';

@Injectable()
export class CategoryService {
  /**
   * Constructor
   *
   * @param {ApiService} apiService
   */
  constructor(private apiService: ApiService) {}

  /**
   * Get tags
   *
   * @param {TagQuery} params
   * @returns {Observable<ApiResponse>}
   */
  getCategories(params: CategoryQuery): Observable<ApiResponse> {
    const httpParams = this.apiService.setHttpParams(params);
    return this.apiService
      .get('/categories', httpParams)
      .pipe(map(response => response));
  }

  /**
   * Get a tag
   *
   * @param {Id} id
   * @returns {Observable<ApiResponse>}
   */
  getCategory(id: string): Observable<ApiResponse> {
    return this.apiService
      .get(`/category/${id}`)
      .pipe(map(response => response));
  }
}
